<template>
  <div v-if="tasks.length > 0">
    <h5 class="my-3">Uploaded files<b-icon icon="arrow-repeat" :animation="(tasksLoading) ? 'spin' : ''" @click.prevent="reloadTasks" class="clickable"></b-icon></h5>

    <b-form-checkbox-group id="checkbox-group" v-model="selected" name="selectedTasks">
    <table class="table">
      <tr>
        <th><b-form-checkbox @change="selectAll()"></b-form-checkbox></th>
        <th>Filename</th>
        <th>Model</th>
        <th>Status</th>
        <th></th>
        <th>Process time</th>
        <th>Uploaded</th>
        <th><!-- action --></th>
        <th><!-- action --></th>
      </tr>
      <tbody name="fade" is="transition-group">
      <tr v-for="(task, index) in tabulatedTasks" :key="index">
        <td><b-form-checkbox :value="task.id" :disabled="task.api_status !== 'completed'"></b-form-checkbox></td>
        <td>{{ task.original_filename }}</td>
        <td class="text-nowrap">
          <small>{{ getModelLabel(task.source_lang) }}<br>
            <b-badge v-if="task.target_features && 'punc' in task.target_features" class="mx-1">punctuation</b-badge>
            <b-badge v-if="task.target_features && 'diar' in task.target_features" class="mx-1">diarization</b-badge>
          </small>
        </td>
        <td>
           <b-icon icon="check-circle-fill" variant="success" v-if="task.api_status === 'completed'" v-b-tooltip.hover title="completed"></b-icon>
          <b-icon icon="x-circle-fill" variant="danger" v-if="task.api_status === 'failed' || (task.api_status !== 'completed' && !isRecent(task))" v-b-tooltip.hover :title="(task.error_msg) ? task.error_msg : 'failed'"></b-icon>
          <!-- <b-icon icon="exclamation-circle-fill" variant="warning" v-if="task.api_status === 'queued' && !isRecent(task)" v-b-tooltip.hover title="processing"></b-icon> -->
          <!-- <b-spinner variant="warning" :small="true" label="processing..." v-if="task.api_status === 'queued' && isRecent(task)" v-b-tooltip.hover title="processing"></b-spinner> -->
          <!-- -------- progress bar -------- -->
          <b-progress :max="100" height="1.4rem" v-if="!['completed', 'failed', 'not uploaded'].includes(task.api_status) && isRecent(task)">
          <b-progress-bar :value="task.api_progress" :max="100"
            :variant="['presigned', 'uploading', 'uploaded'].includes(task.api_status) ? 'info': 'primary'"
            animated>
            <small>{{ task.api_progress }}%</small>
          </b-progress-bar>
          </b-progress>
        </td>
        <td><small>{{ task.api_status }}</small></td>
        <td><span v-if="task.process_time_ms">{{ task.process_time_ms | timedelta }}</span></td>
        <td> {{ task.created_at | fromNow() }}</td>
        <td><b-icon icon="eye"
                    @click.prevent="viewTask(task.id)"
                    v-if="task.api_status === 'completed'"
                    v-b-tooltip.hover title="View transcription"
                    class="clickable"
                    ></b-icon></td>
        <td><b-icon icon="download"
                    @click.prevent="downloadTask(task.id, 'srt')"
                    v-if="task.api_status === 'completed'"
                    v-b-tooltip.hover title="Download SRT"
                    class="clickable"
                    ></b-icon></td>
        <td><b-icon icon="cloud-download"
                    @click.prevent="downloadTask(task.id, 'xml')"
                    v-if="task.api_status === 'completed'"
                    v-b-tooltip.hover title="Download XML"
                    class="clickable"
                    ></b-icon></td>
        <td><b-icon icon="file-arrow-down"
                    @click.prevent="downloadTask(task.id, 'json')"
                    v-if="task.api_status === 'completed'"
                    v-b-tooltip.hover title="Download JSON"
                    class="clickable"
                    ></b-icon></td>
      </tr>
      </tbody>
    </table>
    </b-form-checkbox-group>
    <b-row>
          <b-col cols="4" class="text-center">
              <b-pagination v-if="this.transcribeTasks.length > perPage" size="md" :total-rows="transcribeTasks.length" v-model="currentPage" :per-page="perPage"></b-pagination>
          </b-col>
          <b-col cols="8">
          <table class="pull-right">
            <tr>
              <td>
                <b-button type="button"
                          variant="primary"
                          size="md"
                          class="mx-3 mt-4"
                          :disabled="this.selected.length == 0"
                          @click.prevent="downloadSelected('srt')"
                          >
                  DOWNLOAD SELECTED (SRT)
                </b-button>
              </td>
              <td>
                <b-button type="button"
                          variant="dark"
                          size="md"
                          class="mx-3 mt-4"
                          :disabled="this.selected.length == 0"
                          @click.prevent="downloadSelected('xml')"
                          >
                  DOWNLOAD SELECTED (XML)
                </b-button>
              </td>
              <td>
                <b-button type="button"
                          variant="danger"
                          size="md"
                          class="mx-3 mt-4"
                          :disabled="this.selected.length == 0"
                          @click.prevent="downloadSelected('json')"
                          >
                  DOWNLOAD SELECTED (JSON)
                </b-button>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>

    <b-modal id="modal-view-task"   size="lg" title="Transcription" hide-footer>
      <div class="mx-5">
        <span style="white-space: pre-wrap">
          {{  this.modalText }}
        </span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import apiClient from '@/services/api_client_saas.js'

export default {
  data () {
    return {
      selected: [], // all the selected IDs
      checkAll: false,
      viewId: null, // ID of the task being viewed in the modal dialog
      tasksLoading: false,
      modalText: '',
      currentPage: 1,
      perPage: 10
    }
  },
  computed: {
    tasks () {
      return (typeof this.transcribeTasks !== 'undefined') ? this.transcribeTasks : []
    },
    allSelected () {
      return (this.tasks.length > 0) ? this.tasks.length === this.selected.length : false
    },
    viewedTask () {
      return (this.tasks.length > 0) ? this.tasks.find(x => x.id === this.viewId) : null
    },
    ...mapGetters([
      'languages',
      'transcribeTasks',
      'transcribeModels',
      'getTaskById'
    ]),
    tabulatedTasks () {
      const start = this.perPage * (this.currentPage - 1)
      const end = this.perPage * this.currentPage
      return (this.tasks) ? this.tasks.slice(start, end) : []
    }
  },
  methods: {
    getModelLabel (s) { // get the label for a transcribe model
      const match = this.transcribeModels.filter(x => x.name === s)
      if (match) {
        return match[0].label
      }
      return s
    },
    getExt (s) {
      if (s) {
        const arr = s.split('.')
        return arr[arr.length - 1]
      }
      return ''
    },
    isRecent (task) {
      const td = new Date() - Date.parse(task.created_at)
      var out = td < (2 * 60 * 60 * 1000) // 2 hours
      return out
    },
    viewTask (id) {
      this.viewId = id
      this.$bvModal.show('modal-view-task')
      // if we already have the task and the output has been cached (downloaded) use it
      console.log('In the modal viewer part ! ')
      if (typeof this.viewedTask === 'undefined' || typeof this.viewedTask.output_text === 'undefined') {
        this.modalText = 'loading...'
        apiClient.get(`/tasks/${id}`)
          .then(response => {
            console.log(response.data.output_text)
            this.modalText = response.data.output_text
            this.$store.dispatch('putTask', response.data)
          }).catch(console.error)
      } else {
        this.modalText = this.viewedTask.output_text
      }
    },
    createDownloadFileName (task) {
      if (task.service === 'transcribe' && task.source_lang.endsWith('.bcn')) {
        return task.original_filename + '.srt'
      }
      return task.original_filename + '.txt'
    },
    downloadTask (id, format) {
      const task = this.getTaskById(id)
      const filename = this.createDownloadFileName(task)
      apiClient.get(`/download/file/${id}/${format}`, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/plain' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = filename.replace('.srt', '.' + format)
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
    selectAll () {
      this.checkAll = !this.checkAll
      if (this.allSelected) {
        this.selected = []
      } else if (this.checkAll) {
        this.tasks.forEach(function (task) {
          if (this.includes(task.id) === false) this.push(task.id)
        }, this.selected)
      }
    },
    downloadSelected (format) {
      apiClient.post('/download/zip/' + format, { // post(url, data, config)
        ids: this.selected
      }, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'download'
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
    reloadTasks () {
      this.tasksLoading = true
      this.$store.dispatch('loadTasks', 'transcribe')
      setTimeout(() => { this.tasksLoading = false }, 500)
    },
    reloadIfNecessary () {
      if (this.tasks.filter(t => !['n/a', 'failed', 'completed'].includes(t.status))) {
        this.reloadTasks()
      }
    }
  }
  // created () {
  //   this.interval = setInterval(() => this.reloadIfNecessary(), 20000)
  // },
  // destroy () {
  //   clearInterval()
  // }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .8s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.clickable {
  cursor: pointer
}
</style>
